/** Widescreen board layouts selectable at runtime. */
export type BoardLayout = 'list' | 'cards'

export const BOARD_LAYOUT_OPTIONS: {value: BoardLayout; label: string}[] = [
    {value: 'list', label: 'Rows'},
    {value: 'cards', label: 'Cards'},
]

export const DEFAULT_BOARD_LAYOUT: BoardLayout = 'list'
